export default function useCssVariables() {
    const root: HTMLElement | null = document.querySelector(':root');

    function setCssVariables(variables: { [name: string]: string }) {
        const entries = Object.entries(variables);

        for (const entry of entries) {
            const [name, value] = entry;

            if (root) {
                root.style.setProperty(`--${name}`, value);
            }
        }
    }

    return setCssVariables;
}
